import TaskIdLinkView from "./TaskIdLinkView.js";
import TaskSchedulerDialog from '../TaskSchedulerDialog.js';
import Chip from "@mui/material/Chip";

const statusColors = {
    open: "#007BFF",
    "in-progress": "#FD7E14",
    hold: "#FFC107",
    resolved: "#20C997",
    closed: "#6C757D",
    reopen: "#007BFF",
}

export const TASKS_COLUMNS = [
    {
        field: "id",
        headerName: "Task ID",
        flex: 1,
        minWidth: 150,
        renderCell: (params) => {            
            return <TaskIdLinkView id={params.value} statusId={params.row.statusId} />
        },
    },
     {
        field: "title",
        headerName: "Title",
        flex: 1,
        minWidth: 100,
        renderCell: (params) => params.value?.name,

    },
    {
        field: "priority",
        headerName: "Priority",
        flex: 1,
        minWidth: 100,
        renderCell: (params) => params.value?.name,

    },

    {
        field: "assignee",
        headerName: "Assignee",
        flex: 1,
        minWidth: 100,
        renderCell: (params) => params.value?.name,

    },

    {
        field: "status",
        headerName: "Status",
        flex: 1,
        minWidth: 100,        
         renderCell: (params) => {
            return (
                <Chip
                    label={params.value}
                    color="white"
                    sx={{
                        backgroundColor:
                        statusColors[params.value.toLowerCase()],
                        color: "white",
                    }}
                    size="small"
                />
            )
        },

    },
    
    {
        field: "due",
        headerName: "Due Date",
        flex: 1,
        minWidth: 100,
        renderCell: (params) => params.value?.name,

    },
    {
        field: "ticketId",
        headerName: "Ticket",
        flex: 1,
        minWidth: 100,
        renderCell: (params) => params.value?.name,

    },
    
];

export const TASK_SCHEDULE_COLUMNS = function (bindFunctions) {
    return [
    // {
    //     field: "id",
    //     headerName: "id",
    //     flex: 1,
    //     minWidth: 150,
    //     // renderCell: (params) => {            
    //     //     return <ReportIdLinkView id={params.value} />
    //     // },
    //     renderCell: (params) => params.value?.name,
    // },
     
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      minWidth: 150,
      renderCell: (params) => {
        return (
          <TaskSchedulerDialog
            scheduleId={params.row.id}
            selectedScheduleName={params.row?.name}
            fetchTaskSchdules={bindFunctions.fetchTaskSchdules}
            componentPermissions={bindFunctions.componentPermissions}
            actionType={bindFunctions.actionType}
          />
        );
      },
    },

    // {
    //     field: "name",
    //     headerName: "Name",
    //     flex: 1,
    //     minWidth: 150,
    //     renderCell: (params) => {            
    //         return <ReportIdLinkView editReportId={params.row.id} selectedReport={params.value.name} />
    //     },
    //     renderCell: (params) => params.value?.name,
    // },
    {
        field: "title",
        headerName: "Title",
        flex: 1,
        minWidth: 100,
        renderCell: (params) => params.value?.name,

    },

    {
        field: "description",
        headerName: "Description",
        flex: 1,
        minWidth: 100,
        renderCell: (params) => params.value?.name,

    },

    // {
    //     field: "priorityName",
    //     headerName: "Priority",
    //     flex: 1,
    //     minWidth: 100,
    //     renderCell: (params) => params.value?.name,

    // },
    // {
    //     field: "assetItemName",
    //     headerName: "Asset Item",
    //     flex: 1,
    //     minWidth: 100,
    //     renderCell: (params) => params.value?.name,

    // },
    // {
    //     field: "resolverGroupName",
    //     headerName: "Resolver Group",
    //     flex: 1,
    //     minWidth: 100,
    //     renderCell: (params) => params.value?.name,

    // },
    // {
    //     field: "resolverUserName",
    //     headerName: "Resolver",
    //     flex: 1,
    //     minWidth: 100,
    //     renderCell: (params) => params.value?.name,

    // },
    {
        field: "active",
        headerName: "Active",
        flex: 1,
        minWidth: 100,
        renderCell: (params) => params.value?.name,

    },   
    {
        field: "frequency",
        headerName: "Frequency",
        flex: 1,
        minWidth: 100,
        renderCell: (params) => params.value?.name
    }    
]
}